import type { TrackingAdapter } from './tracking-adapter';

/**
 * Service that handles tracking operations by delegating to a concrete adapter
 */
export class TrackingService {
  constructor(private adapter: TrackingAdapter) {}

  /**
   * Track a custom event with optional properties
   */
  track(event: string, properties?: Record<string, unknown>): void {
    this.adapter.track(event, properties);
  }

  /**
   * Identify a user with optional properties
   */
  identify(userId: string, companyId: string, properties?: Record<string, unknown>): void {
    this.adapter.identify(userId, companyId, properties);
  }

  /**
   * Track a page view
   */
  pageView(page: string, properties?: Record<string, unknown>): void {
    this.adapter.pageView(page, properties);
  }

  /**
   * Reset user identity (e.g., on logout)
   */
  reset(): void {
    this.adapter.reset();
  }

  /**
   * Get the current session ID for tracking
   */
  getSessionId(): string | null {
    return this.adapter.getSessionId();
  }

  /**
   * Get the header name for the session ID
   */
  getSessionIdHeader(): string {
    return this.adapter.getSessionIdHeader();
  }
}
